import React, { useState, createContext, useContext } from 'react';
type ViewMode = 'cards' | 'list' | 'tiles';
interface AppSettingsContextType {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}
const AppSettingsContext = createContext<AppSettingsContextType | undefined>(undefined);
export function AppSettingsProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [viewMode, setViewMode] = useState<ViewMode>('cards');
  return <AppSettingsContext.Provider value={{
    viewMode,
    setViewMode
  }} data-id="element-414">
      {children}
    </AppSettingsContext.Provider>;
}
export function useAppSettings() {
  const context = useContext(AppSettingsContext);
  if (context === undefined) {
    throw new Error('useAppSettings must be used within an AppSettingsProvider');
  }
  return context;
}